module.exports = __webpack_public_path__ + "img/pug.65b16f6a.jpg";